import React, { Component } from "react";
import AuthComponent from "./components/authcomponent";
import PaginatedTracks from "./components/trackscomponent";
import WebPlayback from "./components/webplayback";
import Auth from "./js/auth";
import SpotifyAPI from "./js/spotifyapi";

class App extends Component {
  state = {
    isAuthenticated: false,
    deviceID: "",
  };

  handleAuth = (isAuthenticated) => {
    this.setState({ isAuthenticated });
  };

  handleDeviceReady = (deviceID) => {
    this.setState({ deviceID });
  };

  handlePlayTrack = async (trackURIs, offset) => {
    await SpotifyAPI.playTrack(trackURIs, this.state.deviceID, offset);
  };

  render() {
    return (
      <React.Fragment>
        <AuthComponent onAuthChange={this.handleAuth} />
        <main className="container">
          {this.state.isAuthenticated && (
            <WebPlayback
              token={Auth.getAccessToken()}
              onDeviceReady={this.handleDeviceReady}
            />
          )}
          {this.state.isAuthenticated && this.state.deviceID !== "" && (
            <PaginatedTracks
              itemsPerPage={7}
              onPlayTrack={this.handlePlayTrack}
            />
          )}
        </main>
      </React.Fragment>
    );
  }
}

export default App;
